"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var FacebookVideosDataSource =
/*#__PURE__*/
function () {
  function FacebookVideosDataSource() {
    (0, _classCallCheck2["default"])(this, FacebookVideosDataSource);
  }

  (0, _createClass2["default"])(FacebookVideosDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'Facebook Videos';
    }
  }, {
    key: "getItemId",
    value: function getItemId(item) {
      return item.id;
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      return result.data.map(function (item) {
        return {
          title: item.description,
          time: item.updated_time,
          video: {
            type: 'facebook',
            videoId: item.id,
            autoPlay: 0,
            loop: 0
          }
        };
      });
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value, requestBody) {
      var item = [{
        id: 'accountId',
        value: value
      }];
      requestBody.item = item;
      return requestBody;
    }
  }]);
  return FacebookVideosDataSource;
}();

FacebookVideosDataSource.getRequestName = function () {
  return 'FacebookListVideosApi';
};

var _default = FacebookVideosDataSource;
exports["default"] = _default;